module.exports = __webpack_public_path__ + "static/media/suspicious_text.ed8f0e42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/suspicious_text.jpg
// module id = 207
// module chunks = 0